// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1_M6n","productName":"Table_productName__1Vb3o"};